const generateDocumentNode = contentArr => {
  return {
    nodeType: 'document',
    data: {},
    content: contentArr,
  };
};

const partitionHeaders = richText => {
  const allHeadingIndeces = richText.content
    .map((section, index) => (section.nodeType === 'heading-2' ? index : undefined))
    .filter(i => i !== undefined);

  const arrayOfDocumentObjects = allHeadingIndeces.map((position, index) => {
    if (index === 0 && position > 0) {
      return [
        generateDocumentNode(richText.content.slice(0, position)),
        generateDocumentNode(richText.content.slice(position, allHeadingIndeces[index + 1])),
      ];
    }
    if (index === allHeadingIndeces.length - 1) {
      return generateDocumentNode(richText.content.slice(position, richText.content.length));
    }
    return generateDocumentNode(richText.content.slice(position, allHeadingIndeces[index + 1]));
  });

  return arrayOfDocumentObjects.flat();
};

// Rich Text contains 'Table of Contents' and bullet points as first bit of content inside richText parameter
const parseArticleTableOfContents = richText => {
  let toc;
  let body;

  if (
    richText?.json?.content[0]?.content[0]?.value?.toLowerCase()?.includes('table of content') &&
    richText?.json?.content[1]?.nodeType === 'ordered-list'
  ) {
    toc = { content: richText?.json?.content.slice(0, 2), data: {}, nodeType: 'document' };
    body = {
      content: richText?.json?.content.slice(2, richText?.json?.content.length),
      data: {},
      nodeType: 'document',
    };
  } else {
    toc = null;
    body = richText?.json;
  }

  return { toc, body };
};

// Rich Text generate Table of Contents is set to true
const parseSideBarTableOfContents = richText => {
  const toc = [];
  const allHeadings = richText.json.content.filter(section => section.nodeType === 'heading-2');
  allHeadings.forEach((heading, index) => {
    const anchorId = `toc-${index}`;
    heading?.content?.forEach(nodes => {
      if (nodes.nodeType === 'hyperlink') {
        const richTextValue = nodes.content[0] && nodes.content[0].value;
        const tocTitle = nodes.data?.uri?.startsWith('title=')
          ? nodes.data.uri.split('=')[1]
          : richTextValue;

        toc.push({ title: tocTitle, anchor: `to=#${anchorId}` });
      } else if (nodes.value && nodes.value.trim()) {
        const tocTitle = nodes.value;

        toc.push({ title: tocTitle, anchor: `to=#${anchorId}` });
      }
    });
  });

  const body = partitionHeaders(richText.json);

  return { toc, body };
};

const parseRichTextArticle = (richText, version = 'v1') => {
  return version === 'v1'
    ? parseArticleTableOfContents(richText)
    : version === 'v2' && parseSideBarTableOfContents(richText);
};

export default parseRichTextArticle;
